import React, { useEffect, useState } from 'react';

import Header from '../../../layout/Header';
import Subheader from '../../../layout/Subheader';
import api from '../../../services/api';
import TableContent from './TableContent';
import OperationsMiddle from './OperationsMiddle';
import { useParams } from 'react-router-dom';

import * as S from './styles';
import { useMessageBox } from '../../../context/MessageBox';
import { useNotification } from '../../../context/NotificationContext';
import { TOKEN_USER } from '../../../services/auth';
import Loading from '../../../components/Loading';

export function ClosingMonthReport() {
  const defaultDateFilter = () => {
    const currentDate = new Date()
    const month = currentDate.getMonth()
    const year = currentDate.getFullYear()
    return new Date(year, month -1, 1)
  }

  const [isLoading, setIsLoading] = useState(true);
  const [loader, setLoader] = useState(true);
  const [intervalTime, setintervalTime] = useState(0);
  const [triggerUpdate, setTriggerUpdate] = useState(true);
  const [updateContent, setUpdateContent] = useState(Date.now());
  const [tableData, setTableData] = useState();
  const [totalTableData, setTotalTableData] = useState();
  const [scheduleDate, setScheduleDate] = useState(defaultDateFilter);
  const [selectedItens, setSelectedItens] = useState([])
  const [showFechamento, setShowFechamento] = useState(false)

  useEffect(() => {
    if (intervalTime > 0) {
      const interval = setInterval(() => setUpdateContent(Date.now()), intervalTime);
      return () => {
        clearInterval(interval);
      };
    }
  }, [intervalTime]);

  useEffect(() => {
    setintervalTime(
      Number(
        JSON.parse(
          sessionStorage.getItem('@Capittale-Web-Setting'),
        )?.configuracoesAmbienteWeb?.find((el) => el.parametroId === 40)?.valor ?? 0,
      ) *
        1000 *
        60,
    );
  }, []);

  useEffect(() => {
    isLoading
      ? localStorage.setItem('isLoading', 'true')
      : localStorage.setItem('isLoading', 'false');
    setTimeout(() => {
      setLoader(localStorage.getItem('isLoading') === 'true');
    }, 200);
  }, [isLoading]);

  return (
    <S.Root>
      <Header />
      <Subheader title={"Fechamento Mensal"} back="/app/home" />
      <S.Content>
        <div
          style={{
            width: '100%',
            margin: '30px 30px',
            padding: '0px 20px 20px 20px',
            height: '100%',
            border: '2px solid #ddd',
            borderRadius: '8px',
            backgroundColor: '#eee',
          }}
        >
            <OperationsMiddle
                setTableData={setTableData}
                setTotalTableData={setTotalTableData}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                triggerUpdate={triggerUpdate}
                setTriggerUpdate={setTriggerUpdate}
                setScheduleDate={setScheduleDate}
                scheduleDate={scheduleDate}
                setShowFechamento={setShowFechamento}
                showFechamento={showFechamento}
                selectedItens={selectedItens}
                setSelectedItens={setSelectedItens}
            />
        </div>
      </S.Content>
      {loader ? (
        <Loading />
      ) : (
        <div>
            <TableContent
                tableData={tableData}
                totalTableData={totalTableData}
                scheduleDate={scheduleDate}
                setSelectedItens={setSelectedItens}
                selectedItens={selectedItens}
                setIsLoading={setIsLoading}
            />
        </div>
      )}
    </S.Root>
  );
}
